import React, { useState } from 'react'
import ModalConsentimientoInformado from '../../pages/ModalConsentimientoInformado'
import ModalConsentimientosDeUnUsuario from './ModalConsentimientosDeUnUsuario'
import ModalSeleccionarConsentimientoInformado from './ModalSeleccionarConsentimientoInformado'

const TablaConsentimientoInformadoPrincipal = ({user, setactualizarData}) => {
    const [modalOnConsentimientoInformado, setmodalOnConsentimientoInformado]=useState(false)
    const [modalSeleccionarConsentimientosInformados, setmodalSeleccionarConsentimientosInformados]=useState(false)
    const handleClickConsentimientoInformado=()=>{
        setmodalOnConsentimientoInformado(true)
    }

    const handleClickSeleccionarConsentimientosInformados=()=>{
      setmodalSeleccionarConsentimientosInformados(true)
    }
  return (
    
         
        <tr className="divide-y divide-slate-700 ">
          <td></td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          <button
                      onClick={handleClickSeleccionarConsentimientosInformados}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Consentimientos
                    </button>
          </td>
          {
            user.isconsentimiento === "Si"?
            <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          <button
                      onClick={handleClickConsentimientoInformado}
                      type="button"
                      className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                    >
                      Firma
                    </button>
          </td>
          :
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"></td>

          }
          
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {user.TFTDoc? user.TFTDoc:null}
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {user.TFCedu? user.TFCedu:null }
          </td>
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {user.TFNomC? user.TFNomC:null }
          </td>    
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            {parseInt(user.ClaPro) === 3? 'Urgencias':null}
            {parseInt(user.ClaPro) === 1? 'Ambulatorio':null}
            {parseInt(user.ClaPro) === 2? 'Hospitalización':null}
            {parseInt(user.ClaPro) === 4? 'Atencion Especial':null}
            {parseInt(user.ClaPro) === 5? 'Triage':null}
          </td>  
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {user.TmCtvIng? user.TmCtvIng:null }
          </td>  
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {user.TFFchI? user.TFFchI:null }
          </td>  
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
            
            {user.TFcCodCam? user.TFcCodCam:null }
          </td>  
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            
            {user.MPNomP? user.MPNomP:null }
          </td>  
          <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
            
            {user.TFNomCto? user.TFNomCto:null }
          </td>  
          {modalSeleccionarConsentimientosInformados? <ModalSeleccionarConsentimientoInformado setmodalSeleccionarConsentimientosInformados={setmodalSeleccionarConsentimientosInformados} user={user} setactualizarData={setactualizarData}/>:null}
          {modalOnConsentimientoInformado?<ModalConsentimientosDeUnUsuario setmodalOnConsentimientoInformado={setmodalOnConsentimientoInformado} user={user}/>:null}
        </tr>     
        
       
        
  )
}

export default TablaConsentimientoInformadoPrincipal